<div class="app-alert__message font-15 cursor-default"
     [innerHTML]="item.data.message"></div>
<div class="app-alert__buttons-box">
    <input type="button" [value]="item.data.cancelButton"
           class="app-alert__button bg-cancel color-light font-bold font-14 cursor-pointer"
           *ngIf="item.data.cancelButton !== false"
           (click)="item.data.cancelFunction(key)"/>
    <input type="button" [value]="item.data.okButton"
           class="app-alert__button bg-ok color-light font-bold font-14 cursor-pointer"
           *ngIf="item.data.okButton !== undefined"
           (click)="item.data.okFunction(key)"/>
</div>
